/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type List_suggestions$ref = any;
type SimpleList_suggestions$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LocalContainer_suggestions$ref: FragmentReference;
declare export opaque type LocalContainer_suggestions$fragmentType: LocalContainer_suggestions$ref;
export type LocalContainer_suggestions = $ReadOnlyArray<{|
  +id: string,
  +name: string,
  +$fragmentRefs: List_suggestions$ref & SimpleList_suggestions$ref,
  +$refType: LocalContainer_suggestions$ref,
|}>;
export type LocalContainer_suggestions$data = LocalContainer_suggestions;
export type LocalContainer_suggestions$key = {
  +$data?: LocalContainer_suggestions$data,
  +$fragmentRefs: LocalContainer_suggestions$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LocalContainer_suggestions",
  "type": "PicklistInterface",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "List_suggestions",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SimpleList_suggestions",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '19dfb89644ba11313055a647e6295204';
module.exports = node;
